import { Link } from "@inertiajs/react";
import type { ColumnDef } from "@tanstack/react-table";
import { Eye } from "lucide-react";

import { Button } from "@/components/ui/button";
import { DataTableColumnHeader } from "@/lib/data-table-column-header";
import { supplierPath } from "@/routes";
import type { Supplier } from "@/types";

export const columns: ColumnDef<Supplier>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Nombre" />
    ),
    enableSorting: false,
  },
  {
    accessorKey: "city",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Ciudad" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const city = row.original.city;
      return city ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "phone",
    header: "Teléfono",
    enableSorting: false,
    cell: ({ row }) => {
      const phone = row.original.phone;
      return phone ?? <span className="text-muted-foreground">-</span>;
    },
  },
  {
    accessorKey: "category_name",
    id: "category_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Categoría" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const category = row.original.category;
      return category ? (
        <span>{category.name}</span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "subcategory_name",
    id: "subcategory_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Subcategoría" />
    ),
    enableSorting: false,
    cell: ({ row }) => {
      const subcategory = row.original.subcategory;
      return subcategory ? (
        <span>{subcategory.name}</span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    id: "actions",
    header: "Acciones",
    cell: ({ row }) => {
      const supplier = row.original;

      return (
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link href={supplierPath(supplier)}>
              <Eye className="h-4 w-4" />
              Ver
            </Link>
          </Button>
        </div>
      );
    },
  },
];
